import { RESET, SET_ACTIVITIES, SET_ACTIVITY } from "../../utils/constants";

const initialState = () => ({
  activity: {
    changes: {
      old: {},
      attributes: {}
    }
  }
});

const state = {
  ...initialState(),
  headers: [
    {
      text: "Megnevezés",
      value: "subject",
      divider: true,
      sortable: true
    },
    {
      text: "Módosította",
      value: "causer.name",
      divider: true,
      sortable: true
    },
    {
      text: "Művelet",
      value: "description",
      divider: true,
      sortable: true
    },
    {
      text: "Típus",
      value: "subject_type",
      divider: true,
      sortable: true
    },
    {
      text: "Módosítva",
      value: "created_at",
      divider: true,
      sortable: true
    },
    {
      text: "Lehetőségek",
      value: "actions",
      divider: false,
      sortable: false
    }
  ],
  activities: []
};

const getters = {};

Object.keys(state).forEach(key => {
  Object.assign(getters, {
    [key]: state => state[key]
  });
});

const actions = {
  reset({ commit }) {
    commit(RESET);
  },
  getActivities({ commit, rootGetters, dispatch }) {
    axios({
      method: "GET",
      url: "activities",
      params: rootGetters["Table/params"]
    }).then(response => {
      commit(SET_ACTIVITIES, response.data.data);

      dispatch("Table/rowsLoaded", { ...response.data.meta }, { root: true });
    });
  },
  getActivityById({ commit }, { id }) {
    axios(`/activities/${id}`).then(response => {
      commit(SET_ACTIVITY, response.data.data);
    });
  }
};

const mutations = {
  [RESET](state) {
    Object.assign(state, initialState());
  },
  [SET_ACTIVITIES](state, payload) {
    state.activities = payload;
  },
  [SET_ACTIVITY](state, payload) {
    state.activity = { ...payload };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
